import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BomBulkUpdateService = {

  // Transaction list — DevExtreme DataSource for gc-data-grid
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  // Get single transaction (full state) — for draft edit/load
  getTransaction(transactionId) {
    const requestParams = {
      url: `api/BomBulkUpdateTransactionList`,
      filter: "TransactionId eq " + transactionId + "",
    }
    return ApiService.oDataGet(requestParams);
  },

  // Get transaction record (audit/review mode) — dedicated endpoint with BomOutcomes
  getTransactionRecord(transactionId) {
    return ApiService.get(`api/BomBulkUpdate/${transactionId}`);
  },

  // Save draft (create or overwrite)
  saveDraft(payload) {
    return ApiService.post("api/BomBulkUpdate/SaveDraft", payload);
  },

  // Cancel a draft
  cancel(transactionId) {
    return ApiService.post(`api/BomBulkUpdate/Cancel/${transactionId}`);
  },

  // Execute BOM search
  search(payload) {
    return ApiService.post("api/BomBulkUpdate/Search", payload);
  },

  // Compute per-BOM line diff
  computeDiff(payload) {
    return ApiService.post("api/BomBulkUpdate/ComputeDiff", payload);
  },

  // Check for stale diff
  checkStaleDiff(payload) {
    return ApiService.post("api/BomBulkUpdate/CheckStaleDiff", payload);
  },

  // Execute bulk update (commit transaction)
  apply(transactionId) {
    return ApiService.post("api/BomBulkUpdate/Apply", { TransactionId: transactionId });
  },

};

export { BomBulkUpdateService };
